import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, numeric } from 'vee-validate/dist/rules';

Vue.use(VueRouter);

Vue.config.productionTip = false

extend('required', {
  ...required,
  message: 'This field is required'
});

extend('email', {
  ...email,
  message: 'Has to be a valid mail address'
});

extend('phone', {
  ...numeric,
  message: 'Has to be a number'
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

const router = new VueRouter({
    mode: 'history'
})

new Vue({
  router,
  components: {
    ValidationProvider,
    ValidationObserver
  },
  render: h => h(App),
}).$mount('#app')
